import {StoreType} from '../../../types/sharedTypes';

export const userParamsSelector = (state: StoreType) => {
  return state.userReducer.params;
}

export const allUsersSelector = (state: StoreType) => {
  return state.userReducer.users;
}
